import React from "react";
import { withTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

import { ClusterEmitter } from '../Map/ClusterGroup'

import iconoCapaHeatmap from '../../images/btn_filtros/heatmap_capa.png'
import iconoCapaCluster from '../../images/btn_filtros/cluster_capa.png'
import iconoCapaBlanco from '../../images/btn_filtros/capas_btn_blanco.png'

import i18next from 'i18next';

class TileSelector extends React.Component {

    emitter

    state = {
        heatDisabled: false
    }

    onFilter = (sibicIds, easinIds) => {
        if (sibicIds === null && easinIds === null) {
            this.setState({
                heatDisabled: false
            })
        } else {
            this.setState({
                heatDisabled: true
            })
        }
    }

    componentDidMount() {
        this.emitter = ClusterEmitter.addListener('apply-filters', this.onFilter);
        i18next.on('languageChanged', () => {this.forceUpdate()})
    }

    componentWillUnmount() {
        this.emitter.remove();
    }

    shouldComponentUpdate(nextProps, nextState){
        if (nextState.heatDisabled !== this.state.heatDisabled){
            return true
        }
        if (nextProps.tileType !== this.props.tileType) {
            return true
        }
        return false
    }

    handleChangeTiletype = (e) => {
        document.body.click()
        this.props.handleChangeTiletype(e.target.value)
    }

    render() {

        const { t } = this.props

        return (
            <div className="marco_btn float-right mt-1 mr-1" style={{ backgroundColor: "#000" }}>
                <OverlayTrigger
                    trigger="click"
                    key={'tile_popover'}
                    placement={'bottom'}
                    rootClose
                    overlay={
                        <Popover style={{maxWidth: 400, width: 'auto', minWidth: 400}}>
                          <Popover.Content >
                            {this.renderSelectorContent()}
                          </Popover.Content>
                        </Popover>
                    }>
                        <Button variant="dark" size="sm" className="btn-visor m-1 float-right"><img className="pb-1 mr-2" src={iconoCapaBlanco} alt="icono buscador" />{t("capas")}</Button>
                </OverlayTrigger>
            </div>
        )
    }

    renderSelectorContent = () => {

        const { t } = this.props

        return (
                <div>
                    <div className="row" style={{ display: "flex" }}>
                        <div className="col-2 form-check" style={{ textAlign: "right" }}>
                            <label className="form-check-label" htmlFor="clust">
                                <img width="100%" className="" src={iconoCapaCluster} alt="icono buscador" style={{width: 33, height: 33}}/>
                            </label>
                        </div>
                        <div className="col-4 pt-2 form-check">
                            <input onChange={this.handleChangeTiletype} className="form-check-input" type="radio" id="clust" name="capasMap" value="CLUSTER" checked={this.props.tileType === "CLUSTER"} />
                            <label className="form-check-label" htmlFor="clust">
                                {t("capas-cluster")}
                            </label>
                        </div>
                        <div className="col-2 form-check" style={{ textAlign: "right" }}>
                            <label className="form-check-label" htmlFor="heatm">
                                <img width="100%" className="" src={iconoCapaHeatmap} alt="icono buscador" style={{width: 33, height: 33}}/>
                            </label>
                        </div>
                        <div className="col-4 pt-2 form-check">
                            <input disabled={this.state.heatDisabled ? true: undefined} onChange={this.handleChangeTiletype} className="form-check-input" type="radio" id="heatm" name="capasMap" value="HEAT" checked={this.props.tileType === "HEAT"}/>
                            <label className="form-check-label" htmlFor="heatm">
                                {t("capas-mapaCalor")}
                            </label>
                        </div>
                    </div>
                </div>
        )
    }
}

export default withTranslation()(TileSelector)
